import { featuredCategories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function FeatureGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Najpopularniejsze <span className="text-accent-600">Kakobuy Spreadsheet</span>
            <br />
            <span className="text-accent-600">Kategorie</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <a
            href={featuredCategories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="md:row-span-2 relative rounded-2xl overflow-hidden group cursor-pointer h-64 md:h-full min-h-[480px]"
          >
            <img
              src={featuredCategories[0].image}
              alt={featuredCategories[0].name}
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center mb-3">
                <i className={`${featuredCategories[0].icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-heading text-xl font-semibold text-white mb-1">{featuredCategories[0].name}</h3>
              <p className="font-body text-sm text-white/80">{featuredCategories[0].desc}</p>
            </div>
          </a>

          <a
            href={featuredCategories[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative rounded-2xl overflow-hidden group cursor-pointer h-56 md:h-auto"
          >
            <img
              src={featuredCategories[1].image}
              alt={featuredCategories[1].name}
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <div className="w-9 h-9 rounded-full bg-background-50/90 flex items-center justify-center mb-2">
                <i className={`${featuredCategories[1].icon} text-accent-600 text-base`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-white mb-0.5">{featuredCategories[1].name}</h3>
              <p className="font-body text-xs text-white/80">{featuredCategories[1].desc}</p>
            </div>
          </a>

          <a
            href={featuredCategories[2].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative rounded-2xl overflow-hidden group cursor-pointer h-56 md:h-auto"
          >
            <img
              src={featuredCategories[2].image}
              alt={featuredCategories[2].name}
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <div className="w-9 h-9 rounded-full bg-background-50/90 flex items-center justify-center mb-2">
                <i className={`${featuredCategories[2].icon} text-accent-600 text-base`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-white mb-0.5">{featuredCategories[2].name}</h3>
              <p className="font-body text-xs text-white/80">{featuredCategories[2].desc}</p>
            </div>
          </a>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/kakobuy-spreadsheet-poradnik"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Zobacz pełny poradnik
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}